import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = {
  "data-aos": "fade-up",
  class: "timeline-item"
}
const _hoisted_2 = { class: "title" }
const _hoisted_3 = { class: "mb-2 company" }
const _hoisted_4 = {
  key: 0,
  class: "mt-2 mb-2"
}
const _hoisted_5 = ["href"]
const _hoisted_6 = { class: "mt-2 date" }
const _hoisted_7 = { class: "timeline-middle" }
const _hoisted_8 = { class: "date" }

import {ref, watch} from 'vue';
import {useStore} from 'vuex';


export default /*@__PURE__*/_defineComponent({
  __name: 'TimelineRow',
  props: {
    title: {},
    company: {},
    date: {},
    description: {},
    icon: {},
    isContentRight: { type: Boolean },
    url: {}
  },
  setup(__props: any) {



const store = useStore();
const isDarkMode = ref(store.state.isDarkMode);

watch(
  () => store.state.isDarkMode,
  newValue => {
    isDarkMode.value = newValue;
  },
);

return (_ctx: any,_cache: any) => {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(["timeline-content", {
        'order-3': __props.isContentRight,
        'padding-left': __props.isContentRight,
        'padding-right': !__props.isContentRight,
      }])
    }, [
      _createElementVNode("div", {
        class: _normalizeClass(["card", {
          light: !isDarkMode.value,
        }])
      }, [
        _createElementVNode("h2", _hoisted_2, _toDisplayString(__props.title), 1),
        _createElementVNode("div", _hoisted_3, _toDisplayString(__props.company), 1),
        _createElementVNode("div", null, _toDisplayString(__props.description), 1),
        (__props.url)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createElementVNode("a", {
                href: __props.url,
                target: "_blank",
                rel: "noopener noreferrer",
                class: _normalizeClass(["btn btn-custom btn-sm project-link", {
              'btn-outline-dark-custom': isDarkMode.value,
              'btn-outline-light-custom': !isDarkMode.value,
            }])
              }, " View Project ", 10, _hoisted_5)
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_6, _toDisplayString(__props.date), 1)
      ], 2)
    ], 2),
    _createElementVNode("div", _hoisted_7, [
      _createVNode(_component_font_awesome_icon, {
        icon: ['fas', __props.icon ?? 'briefcase'],
        size: "xl",
        class: _normalizeClass(["icon", {
          light: !isDarkMode.value,
        }])
      }, null, 8, ["icon", "class"])
    ]),
    _createElementVNode("div", {
      class: _normalizeClass(["timeline-date", {'order-1': __props.isContentRight}])
    }, [
      _createElementVNode("h3", _hoisted_8, _toDisplayString(__props.date), 1)
    ], 2)
  ]))
}
}

})